/** @jsx jsx */
import React from 'react';
import cx from 'classnames';
import styled from '@emotion/styled';
import { css, jsx } from '@emotion/react';

export interface ProgressBarProps {
  className?: string;
  progressBarClassName?: string;
  nested?: boolean;
  now?: number;
  min?: number;
  max?: number;
}

const Container = styled.div<ProgressBarProps>`
  height: 8px;

  > :first-of-type {
    border-radius: 10px 0 0 10px;
  }

  > :last-of-type {
    border-radius: 0 10px 10px 0;
  }
`;

const ROUND_PRECISION = 1000;

export function getPercentage(now: number, min: number, max: number) {
  const percentage = ((now - min) / (max - min)) * 100;
  return Math.round(percentage * ROUND_PRECISION) / ROUND_PRECISION;
}

export default class ProgressBar extends React.Component<ProgressBarProps> {
  render() {
    const { className, nested } = this.props;

    if (nested) {
      return this.renderProgressBar();
    }

    return (
      <Container className={cx(className, 'progress')}>
        {this.renderProgressBar()}
      </Container>
    );
  }

  renderProgressBar() {
    const {
      className,
      nested = false,
      now,
      min = 0,
      max = 100,
      progressBarClassName,
      ...props
    } = this.props;

    if (now == null) {
      return props.children;
    }

    const innerStyles = css`
      width: ${getPercentage(now, min, max)}%;
    `;

    return (
      <div
        role='progressbar'
        css={innerStyles}
        className={cx(
          {
            [className as string]: nested,
            [progressBarClassName as string]: !nested,
          },
          ['progress-bar']
        )}
      />
    );
  }
}
